import { lazy } from 'react';

export const StBlackPage = lazy(() => import('./page-list'));